import React from "react";

/*
 * Custom fonts
 * Uncomment below if using custom fonts
 */

import "./static/fonts/fonts.css";
import "lenis/dist/lenis.css";
import Lenis from "lenis";
import { wrapStyledRoot } from "./src/util/styledRoot";

let lenis;

function mountLenis() {
  if (typeof window === "undefined") return;
  if (lenis && typeof lenis.destroy === "function") {
    lenis.destroy();
  }
  lenis = undefined;

  const wrapper = document.querySelector(".full-page-scroll");
  const content = document.querySelector("[data-lenis-content]");

  const options = {
    autoRaf: true,
    anchors: true,
    allowNestedScroll: true,
  };

  if (wrapper && content) {
    lenis = new Lenis({
      ...options,
      wrapper,
      content,
    });
  } else {
    lenis = new Lenis(options);
  }
}

export const onClientEntry = () => {
  /* Lenis mounts in onRouteUpdate (after hydration): it adds classes to the page wrapper,
     and changing the DOM before React 18 hydrates causes a hydration mismatch. */
  /* Last resort if SSR boot veil is still present (e.g. hydration/runtime failure). */
  if (typeof window !== "undefined") {
    window.setTimeout(() => {
      try {
        const { removePageRevealBootVeil } = require("./src/shared/pageRevealOverlay");
        removePageRevealBootVeil();
      } catch {
        /* ignore */
      }
    }, 5000);
  }
};

export const onRouteUpdate = () => {
  mountLenis();
};

export const wrapRootElement = ({ element }) => wrapStyledRoot(element);

/* Must match `wrapPageElement` in gatsby-ssr.js exactly, or React 18 hydration fails. */
export function wrapPageElement({ element, props }) {
  return (
    <>
      <div>{element}</div>
      <div id="modal-root" />
    </>
  );
}
